import './contact.component.scss'

import loadGoogleMapsApi from 'load-google-maps-api'
import IMask from 'imask'

const gmapApiKey = document.querySelector('meta[name="google-api-key"]').content
const contMap = document.querySelector('.contact-map__canvas')
const loadOptions = {
  key: gmapApiKey
}
const mapStyle = [
  {
    'featureType': 'administrative',
    'elementType': 'all',
    'stylers': [
      {
        'saturation': '-100'
      }
    ]
  },
  {
    'featureType': 'administrative.province',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'landscape',
    'elementType': 'all',
    'stylers': [
      {
        'saturation': -100
      },
      {
        'lightness': 65
      },
      {
        'visibility': 'on'
      }
    ]
  },
  {
    'featureType': 'landscape.man_made',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'lightness': '-2'
      }
    ]
  },
  {
    'featureType': 'poi',
    'elementType': 'all',
    'stylers': [
      {
        'saturation': -100
      },
      {
        'lightness': '50'
      },
      {
        'visibility': 'on'
      }
    ]
  },
  {
    'featureType': 'poi',
    'elementType': 'geometry',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'poi',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'road',
    'elementType': 'all',
    'stylers': [
      {
        'saturation': '-100'
      }
    ]
  },
  {
    'featureType': 'road',
    'elementType': 'labels.icon',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'simplified'
      }
    ]
  },
  {
    'featureType': 'road.highway.controlled_access',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'on'
      }
    ]
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'all',
    'stylers': [
      {
        'lightness': '30'
      }
    ]
  },
  {
    'featureType': 'road.local',
    'elementType': 'all',
    'stylers': [
      {
        'lightness': '40'
      }
    ]
  },
  {
    'featureType': 'transit',
    'elementType': 'all',
    'stylers': [
      {
        'saturation': -100
      },
      {
        'visibility': 'simplified'
      }
    ]
  },
  {
    'featureType': 'transit.line',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'transit.station',
    'elementType': 'all',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'featureType': 'water',
    'elementType': 'geometry',
    'stylers': [
      {
        'hue': '#ffff00'
      },
      {
        'lightness': -25
      },
      {
        'saturation': -97
      }
    ]
  },
  {
    'featureType': 'water',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'visibility': 'on'
      },
      {
        'lightness': '64'
      }
    ]
  },
  {
    'featureType': 'water',
    'elementType': 'labels',
    'stylers': [
      {
        'lightness': -25
      },
      {
        'saturation': -100
      }
    ]
  }
]

let mapCoords = {
  lat: 34.0979828012262, 
  lng: -118.36892115767071
}
let pinUrl = 'https://goo.gl/maps/kXFQ3ZzywVh6tQwA9'

const getMapSettings = () => {
  const jsonTag = document.querySelector('.contact .contact-map__canvas + [type="application/json"]')
  if (jsonTag) {
    const obj = JSON.parse(jsonTag.innerHTML)
    
    mapCoords = (obj.coords) ? obj.coords : mapCoords
    pinUrl = (obj.url) ? obj.url : pinUrl
  }
}

getMapSettings()

const addMarker = map => {
  const markersOnMap = [
    {
      url: pinUrl,
      LatLng: [
        mapCoords,
      ]
    },
  ]

  const image = {
    url: '/app/themes/PIT/front/build/images/contact__map-pin.svg',
    size: new google.maps.Size(18, 24),
    scaledSize: new google.maps.Size(18, 24),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(9, 24),
    labelOrigin: new google.maps.Point(9, 24)
  }

  for (let i = 0; i < markersOnMap.length; i++) {
    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng[0],
      map: map,
      icon: image
    })

    const marker__url = markersOnMap[i].url;
    marker.addListener('click', () => {
      window.open(marker__url, '_blank')
    })
  }
}

if (contMap) {
  const els = [
    {
      node: contMap,
      callback() {
        loadGoogleMapsApi(loadOptions).then(function (googleMaps) {
          const map = new googleMaps.Map(contMap, {
            center: mapCoords,
            zoom: 18,
            styles: mapStyle,
            disableDefaultUI: true,
            zoomControl: true,
            mapTypeControl: true,
            fullscreenControl: true
          })
          addMarker(map)
        }).catch(function (error) {
          console.error(error)
        })
      }
    }
  ]

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          els.forEach(el => {
            if (el.node === entry.target) {
              el.callback()
            }
          })
          observer.unobserve(entry.target)
        }
      })
    }, {
      threshold: 0.01,
      rootMargin: '0px 0px 0px 0px'
    }
  )

  els.forEach(el => {
    observer.observe(el.node)
  })
}

const contForm = document.querySelector('.contact-form__wr-form')
if (contForm) {
  const giveInputIcons = () => {
    const inputTel = contForm.querySelector('[type="tel"]')
    const inputEmail = contForm.querySelector('[type="email"]')

    const wrapTel = inputTel.closest('.frm_form_field')
    const wrapEmail = inputEmail.closest('.frm_form_field')

    if (wrapTel && wrapEmail) {
      wrapTel.style.setProperty('--bg-ico', 'url("/app/themes/PIT/front/build/images/contact-form__ico-tel.svg")')
      wrapEmail.style.setProperty('--bg-ico', 'url("/app/themes/PIT/front/build/images/contact-form__ico-mail.svg")')
    }
  }

  const moveCheckbox = () => {
    const dest = contForm.querySelector('.frm_checkbox')
    if (dest) {
      const checkbox = contForm.querySelector('.frm_checkbox input[type="checkbox"]')
      dest.prepend(checkbox)
    }
  }

  const giveTelMask = () => {
    const el = contForm.querySelector('[type="tel"]')
    const maskOptions = {
      mask: '(000) 000-0000'
    }
    IMask(el, maskOptions)
  }

  giveInputIcons()
  moveCheckbox()
  giveTelMask()
}